import React from 'react';
import { useDataContext } from "UIDataHandler";
import CustomerLogo from "Images/CustomerLogo.jsx";

const QuestionPageHeader = ({}) => {
    const { surveyData } = useDataContext();

    return <div className={`flex flex-row justify-between w-full md:flex-row text-2xl md:text-3xl color1-text`}>
        <div className={`logo-container hidden`}>{<CustomerLogo />}</div>
        <div className={`w-full text-left mr-[3px] md:text-center question-header`}>{surveyData.name}</div>
    </div>
};

export default QuestionPageHeader;
